import OfflineQueue from './queue/OfflineQueue';
import DAO from './DAO.js';
import eventHistoriesServices from '../services/eventHistoriesServices';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';

export default class EventHistoriesDAO extends DAO {

  constructor(store) {
    super(store, 'event_history');
    this.OfflineQueue = OfflineQueue;

    this.unsetEventHistory = this.unsetEventHistory.bind(this);
    this.clearEventHistories = this.clearEventHistories.bind(this);
  }

  unsetEventHistory(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearEventHistories() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getEventHistory(id, options) {
    return this._getItem(id, eventHistoriesServices.getEventHistory.bind(this, id, options), options);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_event_histories, options.toIgnore.eventHistories, this.unsetEventHistory, this.clearEventHistories, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/EventHistoriesDAO.js